import removeAccents from 'remove-accents';

// Director and Administrator always see every mission: the api never
// restricts them, whatever perimeter they may still carry.
export const UNRESTRICTED_ROLES = [215, 225];

export const isUnrestrictedRole = (role) =>
  UNRESTRICTED_ROLES.includes(Number(role));

const getMemberFullName = (member) =>
  `${member?.firstname || ''} ${member?.lastname || ''}`.trim();

// "Emma JOHNSON", the way the contacts tab writes a name.
export const formatMemberName = (member) =>
  [member?.firstname, (member?.lastname || '').toUpperCase()]
    .filter(Boolean)
    .join(' ');

const normalizeText = (text) => removeAccents(text).toLowerCase();

export const sortMembersByName = (members) =>
  [...members].sort((a, b) =>
    getMemberFullName(a).localeCompare(getMemberFullName(b), 'fr', {
      sensitivity: 'base',
    }),
  );

// Every typed word must appear in the full name, whatever their order.
export const filterMembersByQuery = (members, query) => {
  const words = normalizeText(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return members;
  return members.filter((member) => {
    const fullName = normalizeText(getMemberFullName(member));
    return words.every((word) => fullName.includes(word));
  });
};

// Same rule as the members: every typed word must appear in the name.
export const filterPerimetersByQuery = (perimeters, query) => {
  const words = normalizeText(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return perimeters;
  return perimeters.filter((perimeter) => {
    const name = normalizeText(perimeter.name || '');
    return words.every((word) => name.includes(word));
  });
};

export const haveSameMemberIds = (a, b) =>
  a.length === b.length && a.every((id) => b.includes(id));

// Account id → names of its active perimeters, in the order of the list (the
// api sorts it by name). `members[].id` is the account, like `id_employee`.
export const groupPerimeterNamesByMember = (perimeters) => {
  const namesByMember = new Map();
  perimeters.forEach((perimeter) => {
    (perimeter.members || []).forEach((member) => {
      const id = String(member.id);
      namesByMember.set(id, [...(namesByMember.get(id) || []), perimeter.name]);
    });
  });
  return namesByMember;
};
